/* Treuespur verified copy fixes + safe performance patch – 2026-09-14 */
(function () {
  'use strict';

  function handle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function replaceExactText(oldText, newText) {
    document.querySelectorAll('.product-information p').forEach(function (p) {
      if ((p.textContent || '').trim() === oldText) p.textContent = newText;
    });
  }

  function apply() {
    var h = handle();
    if (h === 'pet-portrait-necklace') {
      replaceExactText(
        'Die Kette ist in Gold, Silber und Roségold erhältlich und wird aus hochwertigem Chirurgenstahl gefertigt. Reinige sie bei Bedarf vorsichtig mit einem weichen, trockenen Tuch. Bewahre sie getrennt von anderen Schmuckstücken auf.',
        'Made from 304 stainless steel. Available in silver, 18K gold-plated and 18K rose gold-plated finishes. Chain length: 45 cm plus a 5 cm extension. Wipe gently with a soft, dry cloth and store separately from other jewelry.'
      );
    }
    if (h === 'pet-portrait-keychain') {
      replaceExactText(
        'Der Schlüsselanhänger ist in Gold, Silber und Roségold erhältlich und wird aus hochwertigem, allergikerfreundlichem Edelstahl gefertigt. Reinige ihn bei Bedarf vorsichtig mit einem weichen, trockenen Tuch. Bewahre ihn getrennt von anderen Schmuckstücken auf.',
        'The keychain is available in gold, silver and rose gold finishes. Clean gently with a soft, dry cloth and store separately from other jewelry.'
      );
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  setTimeout(apply, 500);

})();
